import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';

import App from 'containers/App';
import registerServiceWorker, { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js